module.exports = __webpack_public_path__ + "static/img/tab-ten-active.31527fa3.png";